import { ReactNode } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { WidgetCard, WidgetCardHeader } from "../ProjectLayout/ui/WidgetCard";
import { sectionStickyTop } from "../ProjectLayout/ui/SectionPage";

type TFrameDocumentProps = {
  crumb: string;
  actions?: ReactNode;
  fill?: boolean;
  children: ReactNode;
};

export function FrameDocument({ crumb, actions, fill, children }: TFrameDocumentProps) {
  return (
    <WidgetCard data-testid="frame-widget" className={cn(fill && "min-h-0 flex-1")}>
      <WidgetCardHeader title={crumb} actions={actions} stickyTop={fill ? undefined : sectionStickyTop(true)} />
      {fill ? (
        <div
          className={cn(
            "min-h-0 flex-1 overflow-hidden rounded-b-2xl",
            "[&_.ProseMirror_h1]:text-[20px]! [&_.ProseMirror_h1]:leading-7! [&_.ProseMirror_h2]:text-[20px]! [&_.ProseMirror_h2]:leading-7!"
          )}
        >
          {children}
        </div>
      ) : (
        <div className="p-5 sm:p-6">
          <div className="mx-auto w-full max-w-[720px]">{children}</div>
        </div>
      )}
    </WidgetCard>
  );
}
